import { useEffect, useMemo, useState, useRef } from 'react';
import FunnelApi from "../../api/FunnelApi";
import { useNavigate } from "react-router-dom";
import ReactDOM from 'react-dom';
import { Modal, Text, Input, Space, Button, Select, TextInput, Flex, Grid, Skeleton, Kbd, Image, Pagination, Group, FileInput, Anchor } from '@mantine/core';
import { IconHelp, IconSearch, IconCheck, IconX, IconUpload } from '@tabler/icons-react';
import { useForm } from '@mantine/form';
import { notifications } from '@mantine/notifications';
import { modals } from '@mantine/modals';
import { SelectTooltip, showWpSyncWarning } from "../../components/GeneralComponent/GeneralComponent";
import { SmartCodeNotDetectedModal } from "./SmartCodeNotDetectedModal";
import { smartCodeGuideFor } from "../GeneralComponent/smartCodeGuides";
import { visiUserId,visiUserData } from '../../GeneralFunction';
import { useAuth } from '../../AuthContext';

interface AddFunnelPageProps {
  handleSelectPageOpenModalProp: any;
  sethandleSelectPageOpenModalProp: any;
  setSystemUsageLoader: any;
  selectedMemberWebsite: any;
  setLoading: any;
  marksalestime: any;
  resetSelection: any;
  setMarksalestime: any;
  loading: any;
  selectedThumbnails: any;
  setSelectedThumbnails: any;
  setVisiSmartCodeModalOpen: any;
  setVisiSmartCodePageId?: any;
  handleRemoveFromfunnel: any;
  handleCheckTrecking: any;
  handleEditOpenModal: any;
  handleDeletePage: any;
  setSelectedPageId: any;
  setAfterAddNewPage: any;
}

export function AddFunnelPage({
  handleSelectPageOpenModalProp,
  sethandleSelectPageOpenModalProp,
  setSystemUsageLoader,
  selectedMemberWebsite,
  setLoading,
  marksalestime,
  resetSelection,
  setMarksalestime,
  loading,
  selectedThumbnails,
  setSelectedThumbnails,
  setVisiSmartCodeModalOpen,
  setVisiSmartCodePageId,
  handleRemoveFromfunnel,
  handleCheckTrecking,
  handleEditOpenModal,
  handleDeletePage,
  setSelectedPageId,
  setAfterAddNewPage
}: AddFunnelPageProps){

	const navigate = useNavigate();
	const { websiteListData } = useAuth();
	const selectedWebsite = useMemo(
		() => (websiteListData || []).find((w:any) => String(w.website_id) === String(selectedMemberWebsite)),
		[websiteListData, selectedMemberWebsite]
	);
	const isShopifySite = String(selectedWebsite?.front_end_framework) === '2';
	// Install guide for this website's platform, shown in the "SmartCode not detected" modal
	const smartCodeGuideUrl = useMemo(
		() => smartCodeGuideFor(selectedWebsite?.front_end_framework, selectedWebsite?.framework_type),
		[selectedWebsite]
	);
	const searchInputRef = useRef(null);
	const pageIconRef = useRef(null);
	const [selectedFile, setSelectedFile] = useState<File | null>(null);
	const [modalOpened, setModalOpened] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalError, setModalError] = useState('');
	const [modalMessage, setModalMessage] = useState('');
	const [modalType, setModalType] = useState('');
	const [urlErrorsList, setUrlErrorsList] = useState([]);
	const [urlsList, setUrlsList] = useState([]);
	const [validUrlsList, setValidUrlsList] = useState([]);
	const [downloadSampleFile, setDownloadSampleFile] = useState('');
	const [shopifyErrorModalOpened, setShopifyErrorModalOpened] = useState(false);

  const handleFileChange = (file: File | null) => {
  	if (!file) return;
	  const isCsv = file.type === 'text/csv' || file.name.endsWith('.csv');
	  if (!isCsv) {
	    notifications.show({
	      color: 'red',
	      icon: <IconX size="1.1rem" />,
	      title: 'Invalid file type',
	      message: 'Please upload a valid .csv file',
	    });
	    return;
	  }
    setSelectedFile(file);
  };

  const handleImportClick = async () => {
	  if (!selectedFile) {
	    notifications.show({
	      color: 'red',
	      icon: <IconX size="1.1rem" />,
	      title: 'Error',
	      message: "Please select a CSV file first.",
	    });
	    return;
	  }

	  const formData = new FormData();
	  formData.append("selected_file", selectedFile);
	  formData.append("systemwebsiteid", selectedMemberWebsite);
	  formData.append("check_validate", 'true');
	  formData.append("member_id", visiUserId());
	  formData.append("login_member_user_id", visiUserData().member_user_id);
    
	  const url = "check_csv_file_data";
	  try {
	    const response = await fetch(`${process.env.REACT_APP_BACKEND_API_BASE_URL}${url}`, {
	      method: "POST",
	      body: formData
	    });

	    if (!response.ok) {
	      if (response.status === 401 || response.status === 400) {
	        navigate("/login");
	      }
	      return;
	    }
	    const data = await response.json();
	    if (data.status === 1) {
	      setSystemUsageLoader(true);
	      const secondFormData = new FormData();
	      secondFormData.append("check_validate", 'false');
	      secondFormData.append("systemwebsiteid", selectedMemberWebsite);
	      secondFormData.append("member_id", visiUserId());
	    	secondFormData.append("login_member_user_id", visiUserData().member_user_id);
	      data.data.valid_urls.forEach(url => {
			    secondFormData.append("valid_urls[]", url);
			  });

	      const secondResponse = await fetch(`${process.env.REACT_APP_BACKEND_API_BASE_URL}${url}`, {
	        method: "POST",
	        body: secondFormData
	      });

	      if (!secondResponse.ok) {
	        if (secondResponse.status === 401 || secondResponse.status === 400) {
	          navigate("/login");
	        }
	      }
	      const secondData = await secondResponse.json();
	      if (secondData.status === 1) {
	      	setSystemUsageLoader(false);
	        notifications.show({
	          color: 'green',
	          icon: <IconCheck size="1.1rem" />,
	          title: 'Success',
	          message: secondData.message,
	        });
	      	setMarksalestime(data.data.updated_time);
	      	setAfterAddNewPage(1);
	      	setSelectedFile(null);
	      }
	    } else if (data.status === 0) {
	    	setSystemUsageLoader(false);
	      setModalTitle(data.message || '');
	      setModalError(data.data.error || '');
	      setModalMessage(data.data.message || '');
	      setModalType(data.type || '');
	      setUrlErrorsList(data.data.url_errors || []);
	      setUrlsList(data.data.urls || []);
	      setValidUrlsList(data.data.valid_urls || []);
	      setModalOpened(true);
	    }
	  } catch (error) {
	    console.log(error);
	    setSystemUsageLoader(false);
	  }
	};

  const handleOkClick = async (validurls:any) => {
  	setSystemUsageLoader(true);
		setModalOpened(false);
		const formData = new FormData();
    formData.append("check_validate", 'false');
    formData.append("systemwebsiteid", selectedMemberWebsite);
    formData.append("member_id", visiUserId());
    formData.append("login_member_user_id", visiUserData().member_user_id);
    validurls.forEach(url => {
	    formData.append("valid_urls[]", url);
	  });
    const url = "check_csv_file_data";
    const response = await fetch(`${process.env.REACT_APP_BACKEND_API_BASE_URL}${url}`, {
      method: "POST",
      body: formData
    });

    if (!response.ok) {
      if (response.status === 401 || response.status === 400) {
        navigate("/login");
      }
    }
    const data = await response.json();
    if (data.status === 1) {
    	setSystemUsageLoader(false);
      notifications.show({
        color: 'green',
        icon: <IconCheck size="1.1rem" />,
        title: 'Success',
        message: data.message,
      });
    	setMarksalestime(data.data.updated_time);
    	setAfterAddNewPage(1);
    	setSelectedFile(null);
    }
  };

  const handleModalClose = () => {
	  setModalOpened(false);
	  setSelectedFile(null);
	};

	const handleShopifyErrorModalClose = () => {
	  setShopifyErrorModalOpened(false);
	};

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = downloadSampleFile; 
    link.download = 'sample.csv'; 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

	const [selectPageModelOpen, setSelectPageModelOpen] = useState(false);
	const [selectPageFunnel, setSelectPageFunnel] = useState([]);
	const [totalPages, setTotalPages] = useState(10);
	const [totalPaginationNo, setTotalPaginationNo] = useState(1);
	const [selectedAllPageValue, setSelectedAllPageValue] = useState('0');
	const [keyword, setKeywords] = useState('');
	const [activePageNo, setActivePageNo] = useState(1);
	const [selectedPageOption, setSelectedPageOption] = useState({});
	// SmartCode-not-detected dialog shown when a page can't be validated
	const [smartCodeDialogOpen, setSmartCodeDialogOpen] = useState(false);
	const [smartCodeDialogPageId, setSmartCodeDialogPageId] = useState<any>(null);
	const [smartCodeDialogPageUrl, setSmartCodeDialogPageUrl] = useState('');
	const smartCodeSuccessRef = useRef<((data: any) => void) | null>(null);
	const [showHelpModal, setShowHelpModal] = useState(false);
	const [helpTargetId, setHelpTargetId] = useState(0);
	const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });

	/*Use All Funnel Form Name*/
  	const form = useForm({
	    initialValues: {
	      url: ''
	    },
  	});

	useEffect(() => {
		if(handleSelectPageOpenModalProp || (keyword && activePageNo && selectedAllPageValue)){
			AddNewPageOpenModal();
		}
	}, [handleSelectPageOpenModalProp, selectedAllPageValue, keyword, activePageNo, marksalestime]);

	useEffect(() => {
	    const handleKeyDown = (event) => {
	      if (event.ctrlKey && event.key === 'k') {
	        event.preventDefault();
	        searchInputRef.current.focus();
	      }
	    };

	    window.addEventListener('keydown', handleKeyDown);

	    return () => {
	      window.removeEventListener('keydown', handleKeyDown);
	    };
  	}, []);

	useEffect(() => {
	  const hasData = Array.isArray(selectPageFunnel) &&
	    selectPageFunnel.some(item =>
	      Array.isArray(item) ? item.length > 0 : !!item
	    );

	  if (!hasData && activePageNo > 1) {
	    setActivePageNo(prev => prev - 1);
	  }
	}, [selectPageFunnel, activePageNo]);

	const AddNewPageOpenModal = () => {
		setSystemUsageLoader(true);
	    FunnelApi.selectpagesfromfunnel({
	      system_website_id: selectedMemberWebsite,
	      checktrackstate: 1,
	      filter: selectedAllPageValue,
	      keyword: keyword,
	      page: activePageNo
	    })
	    .then(response => response.json())
	    .then(data => {
      	if(data.status === 1){
      		setSystemUsageLoader(false);
          	setSelectPageModelOpen(true);
          	setDownloadSampleFile(data.data.sample_file);
          if (data.data.data) {
            setSelectPageFunnel(data.data.data);
            if (data.data.active_page_no !== activePageNo) {
              setActivePageNo(data.data.active_page_no);
            }
            if (data.data.total_pages !== totalPages) {
              setTotalPages(data.data.total_pages);
            }
            if (JSON.stringify(data.data.total_pagination_no) !== JSON.stringify(totalPaginationNo)) {
              setTotalPaginationNo(data.data.total_pagination_no);
            }
          } else{
            setSelectPageFunnel([]);
          }
        }else{
          setSelectedAllPageValue('0');
          setSystemUsageLoader(false);
          setSelectPageModelOpen(false);
          sethandleSelectPageOpenModalProp(false);
          notifications.show({
	          color: 'red',
	          icon: <IconX size="1.1rem" />,
	          title: 'Error',
	          message: data.message,
	        });
        }
      })
      .catch(error => {
        console.error("API Error:", error);
        setSystemUsageLoader(false);
      });
	}

  	const handleSelectPageCloseModal = () => {
  		setKeywords('');
	    setSelectedAllPageValue('0');
	    setActivePageNo(1);
	    setSelectPageModelOpen(false);
	    sethandleSelectPageOpenModalProp(false);
	    resetSelection();
	    setSelectedFile(null);
	    form.reset();
  	};

  	const handleSelectAllPagesValueChange = (selectedAllPageOption) => {
	    setSelectedAllPageValue(selectedAllPageOption);
	    setActivePageNo(1);
  	};

  	/*Add the Page*/
  	const handleAddthePageSubmit = async (formData:any) =>{
	    try {
	    	setSystemUsageLoader(true);
	      const { url } = formData;
	      let no_of_pages_access;

	      const userDataString = atob(localStorage.getItem('visiUserData'));
	      const userData = JSON.parse(userDataString);
	      if (userData && userData && userData.no_of_add_access) {
	        no_of_pages_access = userData.no_of_add_access.no_of_pages_access;
	      }
	      const APIResponse = await FunnelApi.addpage({
	        system_website_id: selectedMemberWebsite,
	        url: url,
	        no_of_pages_access:no_of_pages_access
	      });
	      const APIResultJSON = await APIResponse.json();
	      if (APIResultJSON.status === 1) {
	      	setSystemUsageLoader(false);
	        notifications.show({
	          color: 'green',
	          icon: <IconCheck size="1.1rem" />,
	          title: 'Success',
	          message: APIResultJSON.message,
	        });
	        showWpSyncWarning(APIResultJSON, selectedMemberWebsite);
	        form.reset();
	        setMarksalestime(APIResultJSON.data.updated_time);
	        handleSelectPageCloseModal();
	      	setAfterAddNewPage(1);
	      	if(APIResultJSON.data.shopify_thank_you_page === 'true'){
	      		handleSelectPageCloseModal();
	      	}else{
		        if(APIResultJSON.data.shopify_code_added === 'false'){
		        	if(APIResultJSON.data.show_visismartcode === true){
		      			if (typeof setVisiSmartCodePageId === 'function') {
		      				setVisiSmartCodePageId(APIResultJSON.data.page_id || '');
		      			}
		      			setVisiSmartCodeModalOpen(true);
		        	}else{
						sethandleSelectPageOpenModalProp(true);
		        		AddNewPageOpenModal();
		        	}
		        }else{
		        	setShopifyErrorModalOpened(true);
		        }
		      }
	      } else {
	      	setSystemUsageLoader(false);
	        form.setErrors({ url: APIResultJSON.message });
	      }
	    } catch (error) {
	    	setSystemUsageLoader(false);
	      console.log('error', error);
	    }
  	};

  	const [AllPagesoptions] = useState([
	    { value: '0', label: 'All pages'},
	    { value: '1', label: 'Tested Pages'},
	    { value: '2', label: 'Pages in Funnel'},
	    { value: '3', label: 'Affiliate Pages'},
	    { value: '4', label: 'Other Pages'},
  	]);

  	const handlePageChange = (newPage) => {
	    setActivePageNo(newPage);
  	};

  	const setKeyword = (e) => {
	    setKeywords(e.target.value);
	    setActivePageNo(1);
  	};

  	const handleThumbnailClick = (pageId,pageClass) => {
  		if(pageClass === 'page rotation'){
  			notifications.show({
          color: 'red',
          icon: <IconX size="1.1rem" />,
          title: 'Error',
          message: "A page is used as a rotation page in a classic AB test so not added other Funnel.",
        });
        return;
  		}
  		handleAddtoFunnel(pageId);
  	};

  	// Open the "SmartCode not detected" dialog for a page
  	const openSmartCodeDialog = (pageId:any) => {
	    const page = selectPageFunnel.find((p:any) => p.page_id === pageId);
	    setSmartCodeDialogPageId(pageId);
	    setSmartCodeDialogPageUrl(page && page.page_url ? page.page_url : '');
	    setSmartCodeDialogOpen(true);
  	};

  	// Retry adding the page. force = user chose "Continue Anyway".
  	const attemptAddToFunnel = (force:boolean) => {
	    return FunnelApi.addtofunnel({
	      system_website_id: selectedMemberWebsite,
	      page_id: smartCodeDialogPageId,
	      ...(force ? { force_add: 1 } : {})
	    })
	    .then(response => (response.ok ? response.json() : null))
	    .then(data => {
	      if (data && data.status === 1) {
	        if (smartCodeSuccessRef.current) {
	          smartCodeSuccessRef.current(data);
	        }
	        setSmartCodeDialogOpen(false);
	        return true;
	      }
	      return false;
	    })
	    .catch(() => false);
  	};

  	const handleThumbnailDoubleClick = (pageId:any) =>{
	    setLoading(true);
	    FunnelApi.addtofunnel({
	      system_website_id: selectedMemberWebsite,
	      page_id:pageId
	    })
	    .then(response => {
	      if (response.ok) {
	        return response.json();
	      } else {
	        if (response.status === 401 || response.status === 400) {
	          setLoading(false);
	          navigate("/logout");
	        }
	      }
	    })
	    .then(data => {
	      if(data.status === 1){
	        setMarksalestime(data.data.updated_time);
	        handleSelectPageCloseModal();
	        setLoading(false);
	      } else {
	        smartCodeSuccessRef.current = (d: any) => {
	          setMarksalestime(d.data.updated_time);
	          handleSelectPageCloseModal();
	        };
	        openSmartCodeDialog(pageId);
	        setLoading(false);
	      }
	    })
	    .catch(error => {
	      console.error("API Error:", error);
	      setLoading(false);
	    });
  	};

  	const handleSelectPageAction = (value:any, page_id:any) => {
	    setSelectedPageOption(prevOptions => ({
	        ...prevOptions,
	        [page_id]: ''
	    }));
	    if(value === "addtofunnel"){
	      handleAddtoFunnel(page_id);
	    } else if(value === "remove"){
	      handleRemoveFromfunnel(page_id);
	    } else if(value === "checkTracking"){
	      handleCheckTrecking(page_id);
	    } else if(value === "trackingCode"){
	      setAfterAddNewPage(1);
	      handleSelectPageCloseModal();
	      if (typeof setVisiSmartCodePageId === 'function') {
	        setVisiSmartCodePageId(page_id);
	      }
	      setVisiSmartCodeModalOpen(true);
	    } else if(value === "edit_page"){
	      handleEditOpenModal(page_id);
	    } else if(value === "delete"){
	      handleDeletePage(page_id);
	    } else if(value === "refresh_screenshot"){
	      modals.openConfirmModal({
	      	trapFocus: false,
	        title: 'Refresh Screenshot',
	        children: (
	          <Text size="sm">
	            Your screenshot will be updated soon!!!
	          </Text>
	        ),
	        labels: { confirm: 'Ok', cancel: "Close" },
	        onCancel: () => console.log('Cancel'),
	        onConfirm: () => handleRefreshScreenshot(page_id),
	      });
	    }
  	};

  	const handleAddtoFunnel = (selectedThumbnail) =>{
	    setLoading(true);
	    const targetPageId = selectedThumbnail;
	    FunnelApi.addtofunnel({
	      system_website_id: selectedMemberWebsite,
	      page_id:selectedThumbnail
	    })
	    .then(response => {
	      if (response.ok) {
	        return response.json();
	      } else {
	        if (response.status === 401 || response.status === 400) {
	          navigate("/logout");
	          setLoading(false);
	        }
	      }
	    })
	    .then(data => {
	      if (data.status === 1) {
	        setMarksalestime(data.data.updated_time);
	        setLoading(false);
	        setSelectedThumbnails((prevSelectedThumbnails) => {
			      if (prevSelectedThumbnails.includes(selectedThumbnail)) {
			        return prevSelectedThumbnails.filter(id => id !== selectedThumbnail);
			      } else {
			        return [...prevSelectedThumbnails, selectedThumbnail];
			      }
			    });
	      } else {
	        smartCodeSuccessRef.current = (d: any) => {
	          setMarksalestime(d.data.updated_time);
	          setSelectedThumbnails((prevSelectedThumbnails) => {
	            if (prevSelectedThumbnails.includes(selectedThumbnail)) {
	              return prevSelectedThumbnails.filter(id => id !== selectedThumbnail);
	            } else {
	              return [...prevSelectedThumbnails, selectedThumbnail];
	            }
	          });
	        };
	        openSmartCodeDialog(targetPageId);
	        setLoading(false);
	        resetSelection();
	      }
	    })
	    .catch(error => {
	      console.error("API Error:", error);
	      setLoading(false);
	    });
  	};

  	/* Refresh Screenshot */
  	const handleRefreshScreenshot = async (selectedPageId) =>{
	    setSelectedPageId(selectedPageId);
	    try {
	      const APIResponse = await FunnelApi.refreshscreenshot({
	        system_website_id: selectedMemberWebsite,
	        page_id: selectedPageId
	      });
	      const APIResultJSON = await APIResponse.json();
	      if (APIResultJSON.status === 1) {
	        notifications.show({
	          color: 'green',
	          icon: <IconCheck size="1.1rem" />,
	          title: 'Success',
	          message: APIResultJSON.message,
	        });
	      } else {
	        notifications.show({
	          color: 'red',
	          icon: <IconX size="1.1rem" />,
	          title: 'Error',
	          message: APIResultJSON.message,
	        });
	      }
	    } catch (error) {
	      console.log('error', error);
	    }
  	};

  	const selectPageBoxOption = useMemo(() => ([
	    { value: '', label: 'Choose Action', hidden:'hidden' },
	    { value: 'addtofunnel', label: 'Add to funnel' },
	    { value: 'remove', label: 'Remove from funnel' },
	    { value: 'checkTracking', label: 'Check Tracking' },
	    ...(isShopifySite ? [{ value: 'trackingCode', label: 'VisiSmart Code' }] : []),
	    { value: 'edit_page', label: 'Edit Page' },
	    { value: 'delete', label: 'Delete Page' },
	    { value: 'refresh_screenshot', label: 'Refresh Screenshot' },
  	]), [isShopifySite]);

  	const getPageBoxOptions = (pageClass,selected) => {
  		let options = [...selectPageBoxOption];
  		options = selected ? options.filter(option => option.value !== 'addtofunnel') : options && (!selected) ? options.filter(option => option.value !== 'remove') : options;
  		if(pageClass === "page rotation"){
  			options = options.map(option => {
					if (['addtofunnel', 'remove', 'edit_page', 'delete'].includes(option.value)) {
						return { ...option, disabled: true };
					}
					return option;
				});
  		}
  		return options;
  	};

  	const handleHelpClick = (id:any) => {
	    setShowHelpModal(true);
	    setHelpTargetId(id);
	    if (pageIconRef.current) {
	      const { top, left, width } = pageIconRef.current.getBoundingClientRect();
	      const scrollOffset = window.scrollY;
	      setTooltipPosition({
	        top: top + scrollOffset,
	        left: left + width + 10, 
	      });
	    }
	};

	return (
		<>
		<SmartCodeNotDetectedModal
		  opened={smartCodeDialogOpen}
		  pageUrl={smartCodeDialogPageUrl}
		  guideUrl={smartCodeGuideUrl}
		  onClose={() => setSmartCodeDialogOpen(false)}
		  onRecheck={() => attemptAddToFunnel(false)}
		  onContinueAnyway={() => attemptAddToFunnel(true)}
		  onViewInstructions={() => {
		    if (typeof setVisiSmartCodePageId === 'function') {
		      setVisiSmartCodePageId(smartCodeDialogPageId);
		    }
		    setSmartCodeDialogOpen(false);
		    setVisiSmartCodeModalOpen(true);
		  }}
		/>
		{showHelpModal &&
        ReactDOM.createPortal(
          <div>
            <SelectTooltip
              isVisible={showHelpModal}
              setIsVisible={setShowHelpModal}
              id={helpTargetId}
              tooltipPosition={tooltipPosition} 
            />
          </div>,
        document.body
    )}
		{/*Error Modal*/}
		<Modal
		  opened={modalOpened}
		  onClose={handleModalClose}
		  title={modalTitle}
		  size="lg"
		  zIndex={9999}
		  transitionProps={{ transition: 'fade', duration: 200 }}
		>
		  <div>
		  	{modalError.length > 0 && (
					<div style={{marginLeft: 10}} >{modalError}</div>
				)}
	    	{urlErrorsList.length > 0 && (
				  <div style={{ marginTop: 5 }}>
				    {urlErrorsList.map((item, idx) => (
				      <div key={idx} style={{ marginBottom: 10 }}>
				        <div>{idx + 1}.{item.url}</div>
				        {item.message.length > 0 && (
				        	<div>Error: {item.message}</div>
				        )}
				      </div>
				    ))}
				  </div>
				)}
				{urlsList.length > 0 && (
				  <div style={{ marginTop: 5 }}>
				    {urlsList.map((url, idx) => (
				      <div key={idx}>{idx + 1}. {url}</div>
				    ))}
			      {modalMessage.length > 0 && (
		        	<div>Error: {modalMessage}</div>
		        )}
				  </div>
				)}
				{validUrlsList.length > 0 && (
		    	<>
		    	<p>The rest of the pages will be added.</p>
		    	<p style={{marginTop: '-15px'}}>Continue?</p>
		    	<div style={{ marginTop: 20, display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
					  <Button variant="default" onClick={handleModalClose}>Close</Button>
					  <Button color="blue" onClick={() => handleOkClick(validUrlsList)}>OK</Button>
					</div>
					</>
				)}
				{modalType === 'ok' && (
					<div style={{ marginTop: 20, display: 'flex', justifyContent: 'flex-end'}}>
					  <Button color="blue" onClick={handleModalClose}>OK</Button>
					</div>
				)}
		  </div>
		</Modal>
		{/*Shopify Error Modal*/}
		<Modal
      opened={shopifyErrorModalOpened}
      onClose={handleShopifyErrorModalClose}
      zIndex={9999}
      size="lg"
      transitionProps={{ transition: 'fade', duration: 200 }}
      withCloseButton={false}
    >
      <Text ml={5} fz={16}>The page is added successfully. Please allow the Shopify app 15–20 seconds to inject the VisiSmart script, then you’ll be able to add the pages to your funnel.</Text>
      <Group position="right" mt={10}>
        <Button onClick={handleShopifyErrorModalClose}>Close</Button>
      </Group>
    </Modal>
		{/*New Select Page*/}
	    <Modal.Root opened={selectPageModelOpen} onClose={handleSelectPageCloseModal} style={{ zIndex: 1 }} size="80%" trapFocus={false}>
	      <Modal.Overlay />
	      <Modal.Content>
	        <Modal.Header>
	          <Modal.Title>ADD PAGES TO YOUR FUNNEL <IconHelp ref={pageIconRef} size="1.1rem" color="red" style={{marginBottom:-3, cursor: 'pointer'}} onClick={() => handleHelpClick(114)}/></Modal.Title>
	          <Modal.CloseButton />
	        </Modal.Header>
	        <Modal.Body>
	          <form onSubmit={form.onSubmit((formData) => { handleAddthePageSubmit(formData); })}>
	            <Text size="sm" ml={0} fz={14}>Note: Any page you add must have your VisiSmart Code. </Text>
	            <Text size="sm" mt={10} fz={14} fw={700}>Add pages to Visiopt</Text>
	            <div style={{ display: 'flex',marginBottom: '10px' }}>
	              <Input.Wrapper size="sm" ml={0} fz={14} mt={5}>Enter the url of the page you want to add to Visiopt:</Input.Wrapper>
	              <Space w="xs" />
	              <Input id="url" value={form.values.url} onChange={(event) => form.setFieldValue('url', event.currentTarget.value)} error={form.errors.url && 'Invalid URL'} w={400} ml={0}/>
	              <Space w="xs" />
	              <Button type="submit" size="sm" maw={150}>
	                Add the Page
	              </Button>
	            </div>
	            {form.errors.url && (
	              <span style={{ color: 'red', marginTop: '10px' }}>{form.errors.url}</span>
	            )}
	          </form>
            <Text size="sm" mt={10} fz={14} fw={700}>Upload file to add multiple pages(Only CSV - <Anchor target="_blank" onClick={handleDownload}>Sample File </Anchor>).</Text>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px', gap: '1rem' }}>
				      <FileInput
				        style={{ width: "250px" }}
				        accept=".csv"
				        value={selectedFile}
				        onChange={handleFileChange}
				        icon={<IconUpload size={16} />}
				      />
				      <Button
				        leftIcon={<IconUpload size={16} />}
				        onClick={handleImportClick}
				      >
				        Import File
				      </Button>
				    </div>
	          <Text size="sm" mt={10} fz={14} fw={700}>Select pages for your funnel</Text>
	          <div style={{ display: 'flex',marginBottom: '10px' }}>
	            <Text size="sm" ml={0} fz={14} mt={8}>Pages you already added to Visiopt: </Text>
	            <Space w="xs" />
	            <Select
	              placeholder="All pages"
	              defaultValue="0"
	              data={AllPagesoptions}
	              onChange={(selectedAllPageOption) => handleSelectAllPagesValueChange(selectedAllPageOption)}
	              value={selectedAllPageValue}
	              maxDropdownHeight={300}
	              maw={152}
	              size="sm"
	              dropdownPosition="bottom"
	            />
	            <TextInput
	              ref={searchInputRef}
	              style={{marginLeft:"auto"}}
	              placeholder="Search"
	              icon={<IconSearch size="1rem" />}
	              rightSectionWidth={60}
	              rightSection={
	                <Flex align="center" justify="flex-end">
	                  <Kbd mr={5}>Ctrl+K</Kbd>
	                </Flex>
	              }
	              onChange={setKeyword}
	            />
	          </div>
	          <Grid ml={0} mt={20} mb={20} style={{height: 450,flex: "1 1 auto",overflow: "auto"}}>
	            {selectPageFunnel.map((item, index) => (
	              <div className="visi-page" key={index} style={{marginRight:10}}>
	                <Skeleton visible={loading}>
	                  <div className={`hover-pointer ${item.pageClass}`}
	                      style={{ backgroundColor: (item.selected || selectedThumbnails.includes(item.page_id)) ? '#38d9a9' : '', userSelect: 'none' }} 
	                      onClick={item.selected ? undefined : () => handleThumbnailClick(item.page_id,item.pageClass)}
	                    >
	                    <span title={item.page_url}>
	                      <span className="page-url">{item.page_title}</span>
	                    </span>
	                    <div className="thumbnail" style={{ backgroundImage: `url(${'https://static.visiopt.com/page-thumb/'+item.img_url})` }} title={item.page_url} onDoubleClick={item.selected ? undefined : () => handleThumbnailDoubleClick(item.page_id)}>
	                      {(item.marge_img !== '' && (
	                          <Image
	                          id="merge_img"
	                          src={item.marge_img}
	                          title="This Page is merged with other links"
	                          style={{}}
	                        />
	                        ))
	                      }
	                      {(item.track_check !== '' && (
	                        <Image
	                          id="track_img"
	                          src={item.track_check}
	                          title={item.track_check_title}
	                        />
	                        ))
	                      }
	                    </div>
	                    <span className="page-title">{item.custom_title}</span>
	                  </div>
	                </Skeleton>
	                <Select
	                  placeholder="Choose Action"
	                  onChange={(value) => handleSelectPageAction(value, item.page_id)} 
	                  value={selectedPageOption[item.page_id] || ''}
	                  data={getPageBoxOptions(item.pageClass,item.selected)}
	                  maxDropdownHeight={250}
	                  maw={163}
	                  size="xs"
	                  dropdownPosition="top"
	                />
	              </div>
	            ))}
	          </Grid>
	          {selectPageFunnel.some(item => Array.isArray(item) ? item.length > 0 : true) && (
	          <Pagination.Root total={totalPages} value={activePageNo} onChange={handlePageChange}>
	            <Group spacing={5} position="center">
	              <Pagination.First />
	              <Pagination.Previous />
	              <Pagination.Items />
	              <Pagination.Next />
	              <Pagination.Last />
	            </Group>
	          </Pagination.Root>
	          )}
	          <Group position="right">
	          <Button color='red' size="sm" w={100} onClick={handleSelectPageCloseModal}>Close</Button>
	          </Group>
	        </Modal.Body>
	      </Modal.Content>
	    </Modal.Root>
		</>
	);
}